@optional @link fn getNorm() -> f32 { return 1.0; };

@export fn displayRGB(sample: vec4<f32>) -> vec4<f32> {
  return vec4<f32>(sample.rgb * getNorm(), 1.0);
};

